var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndiaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_504_10526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.18497 0H20.5153C21.1687 0.00374357 21.7003 0.570894 21.7003 1.26345V14.7365C21.7003 15.431 21.1634 16 20.5082 16H1.18497C0.533324 15.9963 0 15.4291 0 14.7365V1.26345C0 0.570894 0.531558 0.00374357 1.18497 0Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.33276H21.7003V10.6673H0V5.33276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.6672H21.7003V14.7365C21.7003 15.4309 21.1634 15.9999 20.5082 15.9999H1.18497C0.533324 15.9962 0 15.4291 0 14.7365V10.6672Z",
    fill: "#128807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8633 8.00004C12.8633 6.82082 11.9627 5.86621 10.8501 5.86621C9.73756 5.86621 8.83691 6.82082 8.83691 8.00004C8.83691 9.1774 9.73756 10.1339 10.8501 10.1339C11.9627 10.1339 12.8633 9.17927 12.8633 8.00004Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6107 7.99996C12.6107 6.9686 11.8231 6.13379 10.85 6.13379C9.87698 6.13379 9.08936 6.9686 9.08936 7.99996C9.08936 9.03131 9.87698 9.86612 10.85 9.86612C11.8231 9.86612 12.6107 9.03131 12.6107 7.99996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2014 8.00009C11.2014 7.79419 11.0442 7.62573 10.85 7.62573C10.6557 7.62573 10.4985 7.79232 10.4985 8.00009C10.4985 8.20599 10.6557 8.37257 10.85 8.37257C11.0442 8.37257 11.2014 8.20599 11.2014 8.00009Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6831 8.25641C12.6901 8.20587 12.6548 8.15908 12.6071 8.15159C12.5594 8.1441 12.5153 8.18154 12.5082 8.23208C12.5012 8.28261 12.5365 8.32941 12.5842 8.3369C12.6336 8.34251 12.6778 8.30695 12.6831 8.25641Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8501 9.86616L10.9101 8.74684L10.8501 8.21338L10.79 8.74684L10.8501 9.86616Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5576 8.75062C12.577 8.70383 12.5541 8.64767 12.5099 8.62896C12.4658 8.60837 12.4128 8.6327 12.3951 8.6795C12.3757 8.72629 12.3987 8.78245 12.4428 8.80116C12.4887 8.81988 12.54 8.79742 12.5576 8.75062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3945 9.80244L10.7265 8.7374L10.7989 8.20581L10.61 8.70558L10.3945 9.80244Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3178 9.19419C12.3478 9.15301 12.3407 9.09499 12.3019 9.06317C12.263 9.03135 12.2083 9.03883 12.1783 9.08001C12.1482 9.12119 12.1553 9.17921 12.1942 9.21103C12.233 9.24285 12.2878 9.2335 12.3178 9.19419Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96875 9.61722L10.5498 8.67945L10.7493 8.1853L10.4456 8.61394L9.96875 9.61722Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9752 9.55552C12.0141 9.5237 12.0211 9.46567 11.9911 9.42449C11.9611 9.38332 11.9063 9.37583 11.8675 9.40765C11.8286 9.43947 11.8216 9.49749 11.8516 9.53867C11.8816 9.57798 11.9381 9.58734 11.9752 9.55552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60498 9.3196L10.3944 8.57276L10.7069 8.15161L10.3096 8.48292L9.60498 9.3196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5583 9.8119C11.6024 9.79131 11.6254 9.73703 11.6059 9.69024C11.5865 9.64344 11.5353 9.61911 11.4912 9.6397C11.447 9.65842 11.4241 9.71457 11.4435 9.76136C11.4611 9.80816 11.5124 9.83062 11.5583 9.8119Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32422 8.93402L10.2708 8.42864L10.6752 8.10669L10.209 8.3182L9.32422 8.93402Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0921 9.94297C11.1398 9.93548 11.1734 9.88869 11.1681 9.83815C11.161 9.78761 11.1168 9.75205 11.0692 9.75766C11.0215 9.76515 10.9879 9.81194 10.9932 9.86248C10.9985 9.91489 11.0427 9.95046 11.0921 9.94297Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14941 8.48292L10.186 8.25456L10.6558 8.05615L10.1543 8.13102L9.14941 8.48292Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6082 9.94286C10.6559 9.95034 10.7001 9.91291 10.7071 9.86237C10.7142 9.81183 10.6789 9.76503 10.6312 9.75755C10.5835 9.75006 10.5394 9.7875 10.5323 9.83804C10.527 9.89045 10.5605 9.93724 10.6082 9.94286Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.08936 7.99992L10.1454 8.06356L10.6487 7.99992L10.1454 7.93628L9.08936 7.99992Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1418 9.8119C10.1859 9.83249 10.2389 9.80816 10.2566 9.76136C10.2742 9.71457 10.253 9.65842 10.2089 9.6397C10.1648 9.61911 10.1118 9.64344 10.0941 9.69024C10.0765 9.73703 10.0976 9.79131 10.1418 9.8119Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14941 7.51709L10.1543 7.86899L10.6558 7.94573L10.186 7.74545L9.14941 7.51709Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72363 9.55552C9.76248 9.58734 9.81723 9.57985 9.84725 9.53867C9.87727 9.49749 9.87021 9.43947 9.83135 9.40765C9.7925 9.37583 9.73776 9.38332 9.70774 9.42449C9.67948 9.46567 9.68655 9.5237 9.72363 9.55552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32422 7.06592L10.209 7.68174L10.6752 7.89325L10.2708 7.5713L9.32422 7.06592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38281 9.19419C9.41283 9.23537 9.46758 9.24285 9.50643 9.21103C9.54528 9.17921 9.55234 9.12119 9.52232 9.08001C9.4923 9.03883 9.43756 9.03135 9.3987 9.06317C9.36162 9.09311 9.35279 9.15301 9.38281 9.19419Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60498 6.68042L10.3096 7.51711L10.7069 7.85028L10.3944 7.42726L9.60498 6.68042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1405 8.75062C9.15992 8.79742 9.21114 8.82175 9.25529 8.80116C9.29944 8.78057 9.3224 8.72629 9.30297 8.67949C9.28354 8.6327 9.23233 8.60837 9.18818 8.62896C9.14403 8.64767 9.12284 8.70196 9.1405 8.75062Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96875 6.38281L10.4456 7.38609L10.7493 7.81473L10.5498 7.32245L9.96875 6.38281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01705 8.25653C9.02412 8.30707 9.06826 8.34263 9.11595 8.33701C9.16363 8.32953 9.19718 8.28273 9.19188 8.23219C9.18482 8.18165 9.14067 8.14609 9.09299 8.15171C9.04354 8.15732 9.00999 8.20412 9.01705 8.25653Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3945 6.19751L10.61 7.29625L10.7989 7.79414L10.7265 7.26255L10.3945 6.19751Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01701 7.74367C9.00995 7.79421 9.04527 7.841 9.09295 7.84849C9.14063 7.85597 9.18478 7.81854 9.19185 7.768C9.19891 7.71746 9.16359 7.67067 9.11591 7.66318C9.06646 7.65757 9.02231 7.69313 9.01701 7.74367Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8501 6.13379L10.79 7.25311L10.8501 7.78657L10.9101 7.25311L10.8501 6.13379Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.14221 7.24952C9.12279 7.29631 9.14574 7.35246 9.18989 7.37118C9.23404 7.3899 9.28702 7.36744 9.30468 7.32064C9.32411 7.27385 9.30115 7.21769 9.257 7.19898C9.21108 7.18026 9.15987 7.20272 9.14221 7.24952Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3058 6.19751L10.9738 7.26255L10.9014 7.79414L11.0903 7.29625L11.3058 6.19751Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.38285 6.8078C9.35283 6.84897 9.3599 6.907 9.39875 6.93882C9.4376 6.97064 9.49234 6.96315 9.52236 6.92197C9.55239 6.88079 9.54532 6.82277 9.50647 6.79095C9.46762 6.75913 9.41287 6.76662 9.38285 6.8078Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7312 6.38281L11.1502 7.32245L10.9507 7.81473L11.2544 7.38609L11.7312 6.38281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72541 6.44445C9.68656 6.47627 9.67949 6.5343 9.70951 6.57548C9.73953 6.61666 9.79428 6.62414 9.83313 6.59232C9.87198 6.5605 9.87905 6.50248 9.84903 6.4613C9.819 6.42012 9.76249 6.4145 9.72541 6.44445Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0951 6.68042L11.3057 7.42726L10.9932 7.85028L11.3905 7.51711L12.0951 6.68042Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1418 6.19001C10.0976 6.2106 10.0765 6.26488 10.0941 6.31167C10.1135 6.35847 10.1648 6.3828 10.2089 6.36221C10.253 6.34162 10.276 6.28734 10.2566 6.24055C10.2389 6.19188 10.1877 6.16942 10.1418 6.19001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3759 7.06592L11.4293 7.5713L11.0249 7.89325L11.4911 7.68174L12.3759 7.06592Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6082 6.05711C10.5605 6.06459 10.527 6.11139 10.5323 6.16193C10.5394 6.21247 10.5835 6.24803 10.6312 6.24241C10.6789 6.23493 10.7142 6.18813 10.7071 6.13759C10.7018 6.08706 10.6577 6.04962 10.6082 6.05711Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5508 7.51709L11.5142 7.74545L11.0444 7.94573L11.546 7.86899L12.5508 7.51709Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.092 6.05711C11.0443 6.04962 11.0002 6.08706 10.9931 6.13759C10.986 6.18813 11.0213 6.23492 11.069 6.24241C11.1167 6.2499 11.1609 6.21246 11.1679 6.16193C11.1732 6.11139 11.1397 6.06272 11.092 6.05711Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6106 7.99992L11.5546 7.93628L11.0513 7.99992L11.5546 8.06356L12.6106 7.99992Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5583 6.18999C11.5141 6.1694 11.4611 6.19374 11.4435 6.24053C11.4241 6.28732 11.447 6.34348 11.4912 6.3622C11.5353 6.38091 11.5883 6.35845 11.6059 6.31166C11.6236 6.26299 11.6024 6.20871 11.5583 6.18999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5508 8.48292L11.546 8.13102L11.0444 8.05615L11.5142 8.25456L12.5508 8.48292Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9752 6.44451C11.9364 6.41269 11.8816 6.42018 11.8516 6.46136C11.8216 6.50254 11.8286 6.56056 11.8675 6.59238C11.9063 6.6242 11.9611 6.61672 11.9911 6.57554C12.0211 6.53436 12.0141 6.47633 11.9752 6.44451Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3759 8.93402L11.4911 8.3182L11.0249 8.10669L11.4293 8.42864L12.3759 8.93402Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3178 6.8078C12.2878 6.76662 12.233 6.75913 12.1942 6.79095C12.1553 6.82277 12.1482 6.88079 12.1783 6.92197C12.2083 6.96315 12.263 6.97064 12.3019 6.93882C12.339 6.907 12.3478 6.8471 12.3178 6.8078Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0951 9.3196L11.3905 8.48292L10.9932 8.15161L11.3057 8.57276L12.0951 9.3196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5596 7.24932C12.5401 7.20252 12.4889 7.17819 12.4448 7.19878C12.4006 7.21937 12.3777 7.27365 12.3971 7.32045C12.4165 7.36724 12.4677 7.3897 12.5119 7.37098C12.556 7.35227 12.5772 7.29798 12.5596 7.24932Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7312 9.61722L11.2544 8.61394L10.9507 8.1853L11.1502 8.67945L11.7312 9.61722Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6832 7.74367C12.6761 7.69313 12.632 7.65757 12.5843 7.66318C12.5366 7.67067 12.5031 7.71746 12.5084 7.768C12.5154 7.81854 12.5596 7.8541 12.6073 7.84849C12.6567 7.84287 12.6903 7.79608 12.6832 7.74367Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3058 9.80244L11.0903 8.70558L10.9014 8.20581L10.9738 8.7374L11.3058 9.80244Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_504_10526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.7003,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiaFlag);
export default __webpack_public_path__ + "static/media/india-flag.fb17776b7ab27ffbd992cab8b216efa7.svg";
export { ForwardRef as ReactComponent };